// src\themes\tolica\components\Thirdgrid.tsx
'use client';

import { Heading } from '@/components/ui/Heading';
import Image from 'next/image';
import Link from 'next/link';

interface ImageInfo {
    url: string;
}

interface GridItem {
    title?: string | null;
    buttonContent?: string | null;
    link?: string | null;
    image: ImageInfo;
}

interface ThirdgridProps {
    data?: {
        items?: GridItem[];
    };
    isHome?: boolean;
}

export default function Thirdgrid({ data, isHome = false }: ThirdgridProps) {
    if (!data || !data.items || data.items.length < 3) {
        return null;
    }

    const items = data.items;

    const renderCard = (
        item: GridItem,
        aspectRatioClass: string = 'aspect-video'
    ) => {
        return (
            <Link
                href={item.link || '#'}
                className={`relative w-full overflow-hidden group block ${aspectRatioClass}`}
            >
                {item.image && <Image
                    src={item.image.url}
                    alt={item.title || 'image'}
                    fill
                    className="object-cover transition duration-500 group-hover:scale-105"
                />}

                {(item.title || item.buttonContent) && (
                    <div className="absolute bottom-0 right-0 space-y-1 p-6 w-full flex flex-col items-start text-primary-900 z-10">
                        {item.title && <Heading level={2}>{item.title}</Heading>}

                        {item.buttonContent && (
                            <span className="inline-block border-b border-primary-900 text-xs">
                                {item.buttonContent}
                            </span>
                        )}
                    </div>
                )}
            </Link>
        );
    };


    return (
        <div className={`col-span-12 grid grid-cols-1 md:grid-cols-5 p-4 gap-4 ${isHome ? 'sm:px-6 lg:px-12' : ''}`}>
            <div className="col-span-1 md:col-span-3">
                {renderCard(items[0], 'aspect-video md:h-full')}
            </div>

            <div className="grid grid-rows-2 col-span-1 md:col-span-2 gap-4">
                <div className="h-full">{renderCard(items[1])}</div>
                <div className="h-full">{renderCard(items[2])}</div>
            </div>
        </div>
    );
}